import React, { useState } from 'react';

import DocsVideo from '../reusable_components/DocsVideo';

import manage_departments_add_new_department from '../videos/manage_departments_add_new_department.mov';
import manage_departments_edit_department_name from '../videos/manage_departments_edit_department_name.mov';
import manage_departments_delete_department from '../videos/manage_departments_delete_department.mov';

import assigning_department_supervisors from '../videos/assigning_department_supervisors.mov';
import manage_departments_dropdown from '../videos/manage_departments_dropdown.mov';
import manage_departments_click_add_new_supervisor from '../videos/manage_departments_click_add_new_supervisor.mov';
import create_new_user from '../videos/create_new_user.mov';
import manage_departments_click_back_and_assign from '../videos/manage_departments_click_back_and_assign.mov';
import manage_departments_final_product from '../videos/manage_departments_final_product.mov';

export default function ManageDepartmentsDocs({ setTopic, userInfo, schoolType, scrollToInstructions }) {
	const [supervisorsTopic, setSupervisorsTopic] = useState('default');

	const chooseManageDepartmentsTopic = (new_topic) => {
		if(supervisorsTopic === new_topic)
		{
			setSupervisorsTopic('default');
		}
		else
		{
			setSupervisorsTopic(new_topic);
		}

		scrollToInstructions('topOfThePage');
	}
	
	return (
		<div className='documentation-page'>
			<div id='topOfThePage' className='step-main-heading'>Manage Departments</div>
			<p>Use this step to check that you have all the correct departments, and to create accounts for any supervisor(s) you want inolved in sectioning, editing constraints, and reviewing placements for their department.</p> 
			<p className='documentation-question-heading'>What do you need help with?</p>
			<div className='choose-topic' style={{margin:'0px 0px 10px 0px'}}>
				<div className={`choose-topic-btn ${supervisorsTopic === 'edit_departments' ? 'choose-topic-btn-selected' : ''}`} onClick={() => chooseManageDepartmentsTopic('edit_departments')}>Set Up Departments</div>
				<div className={`choose-topic-btn ${supervisorsTopic === 'create_users' ? 'choose-topic-btn-selected' : ''}`} onClick={() => chooseManageDepartmentsTopic('create_users')}>Create New Users</div>
			</div>
			{supervisorsTopic === 'edit_departments' &&
			<div className='documentation-container'>
				<h2 className='documentation-page-heading'>Set Up Departments</h2>
				<div className='documentation-question-heading'>What are you looking to do?</div>
				<div className='documentation-container-instruction-option-container'>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('add_department')}>Add a department</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_department_name')}>Edit a department name</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('assign_supervisor')}>Assign a supervisor</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('delete_department')}>Delete a department</div>
				</div>
				<div id='add_department' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Add a new department</div>
					<div className='documentation-step-text'>To add a new department, scroll down to the bottom of your department list, and click on <span className='turquoise-text'>Add New Department</span>. You will need to provide a department name and then click the check to confirm.</div>
					<DocsVideo src={manage_departments_add_new_department}></DocsVideo>
				</div>
				<div id='edit_department_name' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Edit a department name</div>
					<div className='documentation-step-text'>To edit a department name click on the edit button next to the department name and this should open a box to change the name. Click the check mark to save any changes.</div>
					<DocsVideo src={manage_departments_edit_department_name}></DocsVideo>
				</div>
				<div id='assign_supervisor' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Assign a supervisor</div>
					<div className='documentation-step-text'>To assign a supervisor to a department, click Assign a Department Supervisor, and choose the user you&rsquo;d like to be responsible for the department.</div>
					<div className='documentation-step-text'>If you don't see the user listed, you can also create a new user account (check out our <span className='blue-link' onClick={() => chooseManageDepartmentsTopic('create_users')}>instructions on how to create new users</span>)</div>
					<DocsVideo src={assigning_department_supervisors}></DocsVideo>
					<div className='documentation-step-text'><strong className='red-text'>Important</strong>: Department supversiors ONLY have access to their OWN departments. They will not have control over any other department data.</div>
					<div className='documentation-step-text'><strong className='red-text'>Also Important</strong>: The master scheduler (aka admin) can override any decisions made by department supervisors, and will always have final say on the schedule.</div>
				</div>
				<div id='delete_department' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Delete a department</div>
					<div className='documentation-step-text'>To delete a department, click the circle with the x in the top right corner of the department box. You will be warned that deleting a department will remove it from all teachers, courses, and classrooms.</div>
					<div className='documentation-step-text'>If you are sure about this change, click the red Okay and your department should be removed.</div>
					<DocsVideo src={manage_departments_delete_department}></DocsVideo>
				</div>
			</div>
			}
			{supervisorsTopic === 'create_users' &&
			<div className='documentation-container'>
				<h2 className='documentation-page-heading'>Create New Users</h2>
				<div className='documentation-step-container'>
					<h3 className='documentation-container-text-heading-number'>Step 1</h3>
					<div className='documentation-container-text-heading'>Click "Assign a Department Supervisor"</div>
					<div className='documentation-step-text'>To create a new supervisor, click <span className='turquoise-text'>Assign a Department Supervisor</span> under any department. This should open a dropdown menu.</div>
					<DocsVideo src={manage_departments_dropdown}></DocsVideo>
				</div>
				<div className='documentation-step-container'>
					<h3 className='documentation-container-text-heading-number'>Step 2</h3>
					<div className='documentation-container-text-heading'>Click "Add new Supervisor"</div>
					<div className='documentation-step-text'>Now click on the <span className='turquoise-text'>Add new Supervisor</span> option. This should take you to the <span className='turquoise-text'>Settings &gt; Users</span> page</div>
					<DocsVideo src={manage_departments_click_add_new_supervisor}></DocsVideo>
				</div>
				<div className='documentation-step-container'>
					<h3 className='documentation-container-text-heading-number'>Step 3</h3>
					<div className='documentation-container-text-heading'>Add a new Supervisor account</div>
					<div className='documentation-step-text'>Add a new user under the Department Supervisors heading. It will ask you for some general background info (first and last name) as well as the user&rsquo;s email.</div>
					<DocsVideo src={create_new_user}></DocsVideo>
				</div>
				<div className='documentation-step-container'>
					<h3 className='documentation-container-text-heading-number'>Step 4</h3>
					<div className='documentation-container-text-heading'>Click "Back to Previous Screen"</div>
					<div className='documentation-step-text'>Click the link to go back to the previous screen. Now when you open up the dropdown, the new user you created should show up in the list!</div>
					<DocsVideo src={manage_departments_click_back_and_assign}></DocsVideo>
				</div>
				<div className='documentation-step-container'>
					<h3 className='documentation-container-text-heading-number'>Step 5</h3>
					<div className='documentation-container-text-heading'>Add supervisors to departments</div>
					<div className='documentation-step-text'>Add a supervisor to any departments you want. If no supervisor is assigned to a department, then only users with admin accounts will have access to those departments.</div>
					<DocsVideo src={manage_departments_final_product}></DocsVideo>
				</div>
			</div>
			}
		</div>
	);
}
